// app/javascript/controllers/footer_toggle_controller.js
import { Controller } from "@hotwired/stimulus"

// Toggles `.open` on a .footer-section when clicked,
// but DOES NOT toggle when a `.footer-link` <a> is clicked.
export default class extends Controller {
  // Attach this controller to a parent element (e.g., <footer>)
  // and add: data-action="click->footer-toggle#toggle"

  toggle(event) {
    // Ignore clicks on footer links (and their children)
    if (event.target.closest("a.footer-link")) return

    // Find the nearest footer section that was clicked
    const section = event.target.closest(".footer-section")
    if (!section || !this.element.contains(section)) return

    section.classList.toggle("open")
  }
}
